import { Api } from '@axiom/ui';
import type { AhqSubmission } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

type SubmissionCandidatePatch = {
  candidateId: string;
  isActiveForSubmission?: boolean;
  submissionRank?: number | null;
  submissionDescription?: string;
  showCandidateReputation?: boolean | null;
  highlightedExperiences?: Array<{
    id: string;
    experienceVisible: boolean;
    isHighlighted?: boolean | null;
    submissionDescription?: string | null;
  }> | null;
};

export type SubmissionPatchBody = {
  newSubmissionType: AhqSubmission['newSubmissionType']; // This forces submissionLastUpdatedAt to get updated on the backend
  candidates: SubmissionCandidatePatch[];
};

class SubmissionsLegacyApiClass extends Api {
  constructor() {
    super({ domain: EnvUtil.clientApiBase });
  }

  async updateSubmission(
    submissionId: AhqSubmission['submissionId'],
    body: SubmissionPatchBody
  ) {
    return super.write<{ data: null }>({
      endpoint: `/submissions/${submissionId}`,
      method: 'PATCH',
      body,
    });
  }
}

export const SubmissionsLegacyApi = new SubmissionsLegacyApiClass();
